import { useEffect } from "react";

/**
 * usePageMeta — sets document.title and meta description for the current route.
 * Call inside a route component.
 */
export const usePageMeta = ({ title, description }) => {
  useEffect(() => {
    if (title) {
      const fullTitle = title.includes("Nautiqo") ? title : `${title} · Nautiqo`;
      document.title = fullTitle;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    return () => {
      // Reset title on unmount to default
      document.title = "Nautiqo — Gestisci il tuo charter";
    };
  }, [title, description]);
};
